export var WorkspaceDocumentType;
(function (WorkspaceDocumentType) {
    WorkspaceDocumentType["PDF"] = "pdf";
    WorkspaceDocumentType["DOCX"] = "docx";
    WorkspaceDocumentType["PPTX"] = "pptx";
    WorkspaceDocumentType["XLSX"] = "xlsx";
    WorkspaceDocumentType["MD"] = "md";
    WorkspaceDocumentType["TXT"] = "txt";
})(WorkspaceDocumentType || (WorkspaceDocumentType = {}));
export var WorkspaceDocumentIndexStatus;
(function (WorkspaceDocumentIndexStatus) {
    WorkspaceDocumentIndexStatus["PENDING"] = "pending";
    WorkspaceDocumentIndexStatus["REINDEXING"] = "reindexing";
    WorkspaceDocumentIndexStatus["INDEXED"] = "indexed";
    WorkspaceDocumentIndexStatus["FAILED"] = "failed";
})(WorkspaceDocumentIndexStatus || (WorkspaceDocumentIndexStatus = {}));
export var WorkspaceDocumentIndexVersion;
(function (WorkspaceDocumentIndexVersion) {
    WorkspaceDocumentIndexVersion["LEGACY_V1"] = "legacy_v1";
    WorkspaceDocumentIndexVersion["DOCLING_V1"] = "docling_v1";
})(WorkspaceDocumentIndexVersion || (WorkspaceDocumentIndexVersion = {}));
export var WorkspaceDocumentFailureReason;
(function (WorkspaceDocumentFailureReason) {
    WorkspaceDocumentFailureReason["DOCUMENT_NO_TEXT_CONTENT"] = "DOCUMENT_NO_TEXT_CONTENT";
    WorkspaceDocumentFailureReason["DOCUMENT_INDEXING_FAILED"] = "DOCUMENT_INDEXING_FAILED";
    WorkspaceDocumentFailureReason["DOCLING_REQUIRED_DISABLED"] = "DOCLING_REQUIRED_DISABLED";
    WorkspaceDocumentFailureReason["DOCLING_REQUIRED_UNAVAILABLE"] = "DOCLING_REQUIRED_UNAVAILABLE";
    WorkspaceDocumentFailureReason["DOCLING_REQUIRED_CONVERSION_FAILED"] = "DOCLING_REQUIRED_CONVERSION_FAILED";
    WorkspaceDocumentFailureReason["DOCLING_UPGRADE_DISABLED"] = "DOCLING_UPGRADE_DISABLED";
    WorkspaceDocumentFailureReason["DOCLING_UPGRADE_UNAVAILABLE"] = "DOCLING_UPGRADE_UNAVAILABLE";
    WorkspaceDocumentFailureReason["DOCLING_UPGRADE_FAILED"] = "DOCLING_UPGRADE_FAILED";
    WorkspaceDocumentFailureReason["DOCUMENT_REINDEX_IN_PROGRESS"] = "DOCUMENT_REINDEX_IN_PROGRESS";
    WorkspaceDocumentFailureReason["DOCUMENT_MALFORMED"] = "DOCUMENT_MALFORMED";
})(WorkspaceDocumentFailureReason || (WorkspaceDocumentFailureReason = {}));
export const SUPPORTED_WORKSPACE_DOCUMENT_EXTENSIONS = {
    [WorkspaceDocumentType.PDF]: [".pdf"],
    [WorkspaceDocumentType.DOCX]: [".docx"],
    [WorkspaceDocumentType.PPTX]: [".pptx"],
    [WorkspaceDocumentType.XLSX]: [".xlsx"],
    [WorkspaceDocumentType.MD]: [".md"],
    [WorkspaceDocumentType.TXT]: [".txt"],
};
export const SUPPORTED_WORKSPACE_DOCUMENT_MIME_TYPES = {
    [WorkspaceDocumentType.PDF]: ["application/pdf", "application/octet-stream"],
    [WorkspaceDocumentType.DOCX]: [
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/octet-stream",
    ],
    [WorkspaceDocumentType.PPTX]: [
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "application/octet-stream",
    ],
    [WorkspaceDocumentType.XLSX]: [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/octet-stream",
    ],
    [WorkspaceDocumentType.MD]: [
        "text/markdown",
        "text/x-markdown",
        "text/plain",
        "application/octet-stream",
    ],
    [WorkspaceDocumentType.TXT]: ["text/plain", "application/octet-stream"],
};
export const SUPPORTED_WORKSPACE_DOCUMENT_ACCEPT = Object.values(SUPPORTED_WORKSPACE_DOCUMENT_EXTENSIONS)
    .flat()
    .join(",");
//# sourceMappingURL=workspace-document.enum.js.map